module.exports = __webpack_public_path__ + "img/IAE_logo.38d0d5da.png";